import {h, render} from 'preact';
import $ from '@modules/jquery-import';
import PrimaryNav from '@components/navigation/mobile';
import throttle from 'lodash.throttle';
import SiteMapService from '@services/SiteMapService';
import {animEndEventName} from '@util/animation-prefixes';
import {$BODY} from '@config/selectors';

const
    MENU_OPEN_CLASS = 'js-mobile-menu--open',
    SEARCH_OPEN_CLASS = 'js-mobile-search--open',
    $MENU_COLLECTION_SM = '.nav-menu-collection--mobile';

class MobileMenu {
    activeMenuId = 'root-menu';
    inactiveMenuStack = [];
    _menuOpen = false;

    constructor ( $container ) {
        console.warn( '[Init Mobile Header]' );
        this.menuWrap = $container;

        SiteMapService.getTaxonomy().then( data => {
            render( <PrimaryNav.menus taxonomy={data}/>, this.menuWrap[0] );
            render( <PrimaryNav.list taxonomy={data}/>, null, $( '#nav-collection-primary--mobile' )[0] );
            this.initEvents();
        } );
    };

    initEvents () {
        $( window ).on( 'scroll', throttle( this.handleWindowScroll(), 300 ) );

        $( '#nav-bar--desktop' )
            .on( 'touchstart', '.search-results-list', this.onSearchInteract )
            .on( 'click', '[data-action="search-bar-toggle--mobile"]', this.handleSearchMenuClick );

        $( '[data-action="site-menu-toggle--mobile"]' ).on( 'click', this.handleMenuIconClick );

        $( '#nav-site--mobile:not(.hidden)' ).on( 'click', e => {
            if ( e.target === e.currentTarget ) {
                this.closeMenu();
            }
        } );

        this.menuWrap
            .on( 'click', '[data-action-back]', this.handleBackButtonClick )
            .on( 'click', '[data-menu-id]', this.handleMenuClick )
            .on( 'click', 'a[href*="#"]', this.onInPageNavigation );
    }

    /**
     * adds class to body wrapper used to apply collapsing header on mobile
     */
    handleWindowScroll = () => {
        let lastScrollY = 0;
        return () => {
            const isScrollDown = (lastScrollY - window.scrollY) <= -1 && window.scrollY > 0;

            $( $BODY ).toggleClass( 'scrolling-down', isScrollDown );

            lastScrollY = window.scrollY;
        }
    };

    handleMenuIconClick = e => {
        !this._menuOpen ? this.openMenu() : this.closeMenu();
    };

    toggleMenuOverlay = () => {
        $( 'html' ).toggleClass( MENU_OPEN_CLASS, this._menuOpen );
    };

    onInPageNavigation = e => {
        e.stopImmediatePropagation();
        this.closeMenu();
    };

    openMenu = () => {
        this._menuOpen = true;
        this.toggleMenuOverlay();

        this.menuWrap
            .attr( 'data-overlay', 'active' ) // toggle menu overlay
            .find( $MENU_COLLECTION_SM )
            .first()
            .scrollTop( 0 )
            .attr( 'data-state', 'move-from-right' )
            .on( animEndEventName, function () {
                $( this ).off( animEndEventName ).attr( 'data-state', 'open' );
            } );
    };

    closeMenu = () => {
        this._menuOpen = false;
        this.activeMenuId = 'root-menu';
        this.inactiveMenuStack = [];
        this.toggleMenuOverlay();
        // reset all menu panes to initial state
        this.menuWrap
            .attr( 'data-overlay', 'inactive' ) // toggle menu overlay
            .find( $MENU_COLLECTION_SM )
            .attr( 'data-state', 'offcanvas' );
    };

    handleMenuClick = e => {
        e.stopPropagation();

        const menuId = e.currentTarget.getAttribute( 'data-menu-id' );
        // ignore touch on current active menu item
        if ( menuId === this.activeMenuId ) {
            return;
        }

        this.inactiveMenuStack.push( this.activeMenuId );
        this.activeMenuId = menuId;

        // deactivate current slide
        $( e.currentTarget )
            .parents( $MENU_COLLECTION_SM )
            .attr( 'data-state', 'inactive' );

        // activate next menu slide (by id)
        this.menuWrap
            .find( `${$MENU_COLLECTION_SM}[data-menu-id=${menuId}]` )
            .removeAttr( 'data-menu-unviewed' )
            .attr( 'data-state', 'move-from-right' );
    };

    onSearchInteract = () => {
        // hide virtual keyboards on search result interaction
        if ( document.activeElement ) {
            document.activeElement.blur();
        }
    };

    handleSearchMenuClick = e => {
        e.stopPropagation();

        const doc = $( 'html' );
        const searchWrap = $( '#search-bar-wrapper--header' );
        const searchHeader = $( '#search-query--header' );

        doc.toggleClass( SEARCH_OPEN_CLASS );

        const IS_OPEN = doc.hasClass( SEARCH_OPEN_CLASS );

        if ( IS_OPEN ) {
            searchHeader.focus();
        }

        searchWrap.attr( 'data-state', IS_OPEN ? 'open' : 'closed' );
    };

    handleBackButtonClick = e => {
        e.stopPropagation();

        // set current active slide to off
        $( e.currentTarget )
            .parents( `.nav-menu-collection--mobile` )
            .attr( 'data-state', 'offcanvas' );

        // get previous inactive menu to reactivate
        const prevMenuId = this.inactiveMenuStack.pop();
        this.activeMenuId = prevMenuId;

        this.menuWrap
            .find( `${$MENU_COLLECTION_SM}[data-menu-id=${prevMenuId}]` )
            .attr( 'data-state', 'move-from-left' )
            .on( animEndEventName, function () {
                $( this ).off( animEndEventName )
                    .attr( 'data-state', 'open' )
            } );
    };

}

export default MobileMenu;
